import React from 'react';
import { Formik } from "formik";
import * as Yup from 'yup';

const validationSchema = Yup.object({
    usuario: Yup.number(),
    f_inicio: Yup.date(),
    f_fin: Yup.date().when("f_inicio", (started, yup) => started && yup.min(started, "No pude ser menor a la fecha inicio"))
});

export default function Formbusqueda(props) {
    const { Users, Search, ChangeUser,Reset,Usuario, ValidateUser } = props;
    return (
        <Formik
            initialValues={{
                usuario: '0',
                f_inicio: '',
                f_fin: ''
            }}
            validationSchema={validationSchema}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                //alert("pass " + $("#usuario").val());
                Search(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <form onSubmit={handleSubmit} autoComplete="off" >
                    <div className='row'>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Usuarios:</label>
                                <select name="usuario" id="usuario" className='form-select form-select-sm' value={values.usuario || ''} onChange={v => {
                                    let user = parseInt(v.target.value);
                                    if (user > 0) {
                                        
                                        
                                        //console.log("diaMayor",DiaMayor);
                                        let find = Users.find(element => element.id === user);
                                        let ItemM;
                                        if(Usuario.tipo_usuario == 2){
                                            const DiaMayor = Users.reduce((prev, current) => {
                                                return prev.dias_credito > current.dias_credito ? prev : current;
                                            });
                                            ItemM=DiaMayor;
                                        }else{
                                            //ItemM=find;
                                            ItemM=Usuario;
                                        }
                                        //let fechaI = find && find.dias_credito > 0 ? moment().subtract(find.dias_credito, 'd').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                                        let fechaI = ItemM && ItemM.dias_credito > 0 ? moment().subtract(ItemM.dias_credito, 'd').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                                        setFieldValue("f_inicio", fechaI);
                                        setFieldValue("f_fin", moment().format('YYYY-MM-DD'));
                                    }else{
                                        setFieldValue("f_inicio", '');
                                        setFieldValue("f_fin",'');
                                    }
                                    ValidateUser(user);
                                    setFieldValue("usuario", user);
                                    Reset();
                                }}>
                                    <option value="0">Seleccione uno</option>
                                    {Usuario.tipo_usuario > 1 && (
                                         <option value={Usuario.id}>{Usuario.nombre}</option>
                                    )}
                                    {Users && Users.map((item, key) => (
                                        <option value={item.id} key={key}>{item.nombre}</option>
                                    ))}
                                    
                                </select>
                                <span className="help-block">{errors.usuario}</span>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Fecha Inicio:</label>
                                <input type="date" name='f_inicio' className='form-control form-control-sm' value={values.f_inicio || ''} onChange={handleChange} />
                                <span className="help-block">{errors.f_inicio}</span>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Fecha Fin:</label>
                                <input type="date" name='f_fin' className='form-control form-control-sm' value={values.f_fin || ''} onChange={handleChange} />
                                <span className="help-block">{errors.f_fin}</span>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group" style={{ paddingTop: '30px' }}>
                                <button type='submit' className='btn btn-primary btn-sm mt-30'>Buscar</button>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </Formik>
    )
}
